// React imports
import { useState } from "react";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
// Component Imports
import { Loading } from "../../components/Loading";
import DashboardCardRow from "./DashboardCardRow";
import { ComponentAuthorisation } from "../../components/ComponentAuthorisation";
// State Import
import { useDashboard } from "../../state/dashboardState";
// Utils
import { useDashboardTiles } from "../../utils/DashboardTiles";
// MUI
import Box from "@mui/material/Box";

export function Dashboard({ user }) {
  const [dashInfo, setDashInfo] = useState({});
  // Fetch Dashboard Info
  const { data, isSuccess, isPending } = useDashboard();
  // Success Function
  const successFunc = () => setDashInfo(data.data.data.data.dashboard.data);
  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);
  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);
  const tiles = useDashboardTiles(dashInfo);
  return (
    <>
      {isPending && <Loading />}
      {isSuccess && (
        <Box>
          {user.staffRequestCreate === "true" ? (
            <></>
          ) : (
            <ComponentAuthorisation allowedRoles={["alloworders"]}>
              <DashboardCardRow title="Orders" cards={tiles.orderTiles} />
            </ComponentAuthorisation>
          )}

          <ComponentAuthorisation allowedRoles={["staffRequestCreate"]}>
            <DashboardCardRow
              title="Requests"
              cards={tiles.staffRequestTiles}
            />
          </ComponentAuthorisation>

          <ComponentAuthorisation allowedRoles={["staffRequestApprove"]}>
            <DashboardCardRow
              title="Approvals"
              cards={tiles.staffRequestApprovalTiles}
            />
          </ComponentAuthorisation>

          <ComponentAuthorisation allowedRoles={["allowstaff"]}>
            <DashboardCardRow title="Staff" cards={tiles.staffTiles} />
          </ComponentAuthorisation>

          <ComponentAuthorisation allowedRoles={["allowwardrobe"]}>
            <DashboardCardRow title="Wardrobes" cards={tiles.wardrobeTiles} />
          </ComponentAuthorisation>

          <ComponentAuthorisation allowedRoles={["allowreturns"]}>
            <DashboardCardRow title="Returns" cards={tiles.returnTiles} />
          </ComponentAuthorisation>

          <ComponentAuthorisation allowedRoles={["allowentitlement"]}>
            <DashboardCardRow
              title="Entitlement"
              cards={tiles.entitlementTiles}
            />
          </ComponentAuthorisation>

          <ComponentAuthorisation allowedRoles={["allowfinances"]}>
            <DashboardCardRow title="Finance" cards={tiles.financeTiles} />
          </ComponentAuthorisation>

          <DashboardCardRow title="General" cards={tiles.adminTiles} />
        </Box>
      )}
    </>
  );
}
